<template>
  <div class="mobile-about">
    <section class="section1">
      <div class="top-content">
        <div class="content-left">
          <h1 :class="{ h1: locale === 'en' }" v-animate class="page-title">
            {{ $t("about.text1") }}
          </h1>
          <div v-animate class="info-content">
            <div>
              <p v-html="$t('about.text2')"></p>
            </div>
            <div>
              <p v-html="$t('about.text3')"></p>
            </div>
            <div>
              <p v-html="$t('about.text4')"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="top-brand-animate">
        <canvas ref="brandCanvas" class="brand-canvas"></canvas>
      </div>
    </section>

    <section class="section2">
      <h1 v-animate class="page-title">{{ $t("about.text5") }}</h1>

      <div class="content-box">
        <div class="box-item" v-for="(item, index) in courseData" :key="index">
          <span class="item-time">{{ item.time }}</span>
          <div class="item-circle--box">
            <div class="item-circle">
              <div class="item-circle-inner"></div>
            </div>
          </div>
          <div class="item-desc">
            <div v-animate>{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="about-animation">
        <div class="animation-box animation-top">
          <span>{{ $t("about.text6") }}</span>
        </div>
        <div class="animation-box animation-bottom">
          <span>
            {{ $t("about.text7") }}
          </span>
        </div>

        <div class="animation-other">
          <div class="shadow-box shadow-box-bottom"></div>

          <div class="line line1"></div>
          <div class="line line2"></div>
          <div class="line line3"></div>
        </div>

        <div class="animation-brand" :class="{ 'animation-brand-active': isActive }">
          <img src="@/assets/images/influenbase-about-brand1.png" alt="" />
          <img src="@/assets/images/influenbase-about-brand2.png" alt="" />
          <img class="hidden" src="@/assets/images/influenbase-about-brand3.png" alt="" />
          <img class="hidden" src="@/assets/images/influenbase-about-brand4.png" alt="" />
          <img src="@/assets/images/influenbase-about-brand5.png" alt="" />
          <img src="@/assets/images/influenbase-about-brand6.png" alt="" />
          <img src="@/assets/images/influenbase-about-brand7.png" alt="" />
          <img class="hidden" src="@/assets/images/influenbase-about-brand8.png" alt="" />
          <img class="hidden" src="@/assets/images/influenbase-about-brand9.png" alt="" />
        </div>
      </div>

      <div class="about-case">
        <div class="case-left">
          <div v-animate class="case case1">
            <img src="@/assets/images/influenbase-about-case1.png" alt="" />
          </div>
          <div v-animate class="case case2">
            <img src="@/assets/images/influenbase-about-case3.png" alt="" />
          </div>
        </div>
        <div class="case-right">
          <div v-animate class="case case1">
            <img src="@/assets/images/influenbase-about-case2.png" alt="" />
          </div>
          <div v-animate class="case case2">
            <img src="@/assets/images/influenbase-about-case4.png" alt="" />
          </div>
          <div v-animate class="case case3">
            <img src="@/assets/images/influenbase-about-case5.png" alt="" />
          </div>
          <div v-animate class="case case4">
            <p>
              <span>{{ $t("about.text8") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text9") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text10") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text12") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text13") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text14") }}</span>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section4">
      <h1 v-animate class="page-title">{{ $t("about.text15") }}</h1>
      <p v-animate>{{ $t("about.text16") }}</p>
      <p v-animate>{{ $t("about.text17") }}</p>
      <!-- <p v-animate>{{ $t("about.text18") }}</p>
      <p v-animate>{{ $t("about.text20") }}</p> -->

      <div class="img-box">
        <img src="@/assets/images/influenbase-about-case-1.webp" alt="" />
        <img src="@/assets/images/influenbase-about-case-2.webp" alt="" />
        <template v-if="locale === 'zh'">
          <div class="img-box3">
            <img src="@/assets/images/influenbase-about-case-zh4.webp" alt="" />
            <img src="@/assets/images/influenbase-about-case-zh1.webp" alt="" />
            <img src="@/assets/images/influenbase-about-case-zh2.webp" alt="" />
            <img src="@/assets/images/influenbase-about-case-zh3.webp" alt="" />
          </div>
        </template>
        <template v-else>
          <img src="@/assets/images/influenbase-about-case-en3.webp" alt="" />
        </template>
      </div>
    </section>

    <section class="section5">
      <img v-animate src="@/assets/images/influenbase-carousel-icon2.png" alt="" />
      <span v-animate>{{ $t("about.text21") }}</span>
    </section>

    <img
      class="w-[100px] h-[131px] fixed right-[40px] top-[48vh] cursor-pointer tool-img"
      :src="toolImg"
      alt=""
      @click="handleOpenDialog"
    />
    <contactDialog v-model="showDialog"></contactDialog>
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, onMounted, nextTick } from "vue";
import { onBeforeUnmount } from "vue";
import { shallowRef } from "vue";
import { ref } from "vue";
import contactDialog from "@/components/Dialog/contactDialogH5.vue";
import { usePageAbout } from "@/hooks/usePageAbout.ts";
import logo1 from "@/assets/images/influenbase-about-brand-logo1.png";
import logo2 from "@/assets/images/influenbase-about-brand-logo2.png";
import logo3 from "@/assets/images/influenbase-about-brand-logo3.png";
import logo4 from "@/assets/images/influenbase-about-brand-logo4.png";
import logo5 from "@/assets/images/influenbase-about-brand-logo5.png";
import { useCanvasScroller } from "@/hooks/useCanvasScroller";
const { toolImg, handleOpenDialog, showDialog, courseData, locale } = usePageAbout();

const isActive = ref(false);
let animationBottomRef: HTMLElement | null = null;

// Canvas scroller hook
const {
  canvasRef: brandCanvas,
  start: startBrandScroll,
  stop: stopBrandScroll,
  setOptions: setBrandScrollOptions,
} = useCanvasScroller({
  rowsImages: [[logo1, logo2, logo3, logo4, logo5]],
  rows: 1,
  speed: 60,
  gap: 60,
  paddingX: 20,
  itemHeight: 30,
  rowSpacing: 20,
  direction: "right",
});

// 节流函数
const throttle = (func: Function, delay: number) => {
  let timeoutId: number | null = null;
  let lastExecTime = 0;
  return function (...args: any[]) {
    const currentTime = Date.now();

    if (currentTime - lastExecTime > delay) {
      func(...args);
      lastExecTime = currentTime;
    } else {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
        lastExecTime = Date.now();
      }, delay - (currentTime - lastExecTime));
    }
  };
};

const setIsActive = () => {
  // 使用缓存的元素引用，避免重复查询
  if (!animationBottomRef) {
    animationBottomRef = document.querySelector(".animation-bottom");
  }

  if (animationBottomRef) {
    const rect = animationBottomRef.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // 当 animation-bottom 元素出现在窗口中时
    if (rect.top < windowHeight && rect.bottom > 0 && !isActive.value) {
      isActive.value = true;
    }
  }
};

// 使用节流的滚动处理函数
const throttledSetIsActive = throttle(setIsActive, 16); // 约60fps

onMounted(() => {
  // 立即添加监听器
  window.addEventListener("scroll", throttledSetIsActive, { passive: true });

  // 使用nextTick确保DOM完全渲染后再检查
  nextTick(() => {
    setIsActive();
  });
  // 初始化品牌滚动画布
  nextTick(() => {
    startBrandScroll();
  });
});

onUnmounted(() => {
  window.removeEventListener("scroll", throttledSetIsActive);
  stopBrandScroll();
});
</script>

<style scoped lang="scss">
.mobile-about {
  min-height: 100vh;
  padding-top: 3.25rem; /* 为固定导航栏留出空间 */
  background: #fefcff;
  width: calc(100vw);
  padding: 0 30px;
  padding-top: 230px;
  overflow-x: hidden;
}

.page-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 64px;
  color: #000000;
}

.tool-img {
  z-index: 20;
}

.section1 {
  .top-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .content-left {
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-family: PingFang SC, PingFang SC;
      font-weight: 300;
      font-size: 28px;
      color: #000000;
      line-height: 40px;

      h1 {
        margin-bottom: 80px;
      }

      div {
        margin-bottom: 30px;
        :deep(span) {
          font-weight: 500;
          font-size: 28px;
        }
      }
      div:last-child {
        margin-bottom: 0;
      }
    }
  }

  .top-brand-animate {
    margin: auto;
    width: 100vw;
    overflow: hidden;
    .brand-canvas {
      display: block;
      width: 100%;
      margin-top: 100px;
    }
  }
}

.section2 {
  margin-top: 172px;
  text-align: center;

  .content-box {
    position: relative;
    margin-top: 80px;
    height: auto;

    .box-item {
      margin-right: 35px;
      display: flex;
      margin-bottom: 100px;
      align-items: stretch; // 子项自动和父容器等高
      height: auto; // 高度仍由内容决定

      .item-time {
        font-family: Techna Sans, Techna Sans;
        font-weight: 500;
        font-size: 36px;
        color: #9038ff;
        margin-right: 30px;
        line-height: 40px;
      }

      .item-circle--box {
        flex: 0 0 auto; // 不压缩，不拉伸宽度
        align-self: stretch; // 强制垂直方向填满父级
        border-left: solid 4px #c8a4f6;
        position: relative;
        transform: translateX(22px);

        &::before {
          content: "";
          width: 4px;
          height: 100px;
          position: absolute;
          background-color: #c8a4f6;
          left: 0;
          transform: translateX(-4px);
          top: -100px;
        }
        .item-circle {
          transform: translateX(-25px);
          width: 48px;
          height: 48px;
          background: #f1e5ff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          .item-circle-inner {
            position: absolute;
            z-index: 2;
            width: 18px;
            height: 18px;
            background: #9038ff;
            border-radius: 50%;
          }
        }
      }

      .item-desc {
        flex: 1;
        padding: 30px;
        background: #ffffff;
        box-shadow: 0px 16px 20px 0px rgba(187, 172, 195, 0.18);
        border-radius: 12px 12px 12px 12px;
        text-align: left;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        line-height: 40px;
        position: relative;
        margin-left: 60px;

        &::before {
          content: "";
          width: 80px;
          height: 4px;
          background: #9038ff;
          position: absolute;
          left: -40px;
          transform: translateX(-50%);
          top: 22px;
        }
      }
    }
    .box-item:first-child {
      .item-circle--box {
        &::before {
          height: 50px;
          top: -50px;
        }
      }
    }
    .box-item:last-child {
      margin-right: 0;
    }
  }
}

.section3 {
  position: relative;
  margin-top: -200px;
  .about-animation {
    height: auto;
    position: relative;
    transform: scale(0.6);

    .animation-box {
      height: 601px;
      justify-content: center;
      align-items: flex-end;
      display: flex;
      font-weight: 400;
      font-size: 48px;
      color: #000000;

      span {
        margin-bottom: 20px;
      }
    }

    .animation-bottom {
      color: #858481;
      font-size: 28px;
      align-items: flex-start;

      span {
        display: block;
        width: 500px;
        margin-top: 20px;
        text-align: center;
      }
    }

    .animation-other {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .line {
        z-index: 0;
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        border: 1px solid #bfb9ea;
        opacity: 0.66;
        transform: translateX(-50%) translateY(calc(-50%));
      }

      .line1 {
        width: 640px;
        height: 640px;
      }

      .line2 {
        width: 952px;
        height: 952px;
      }
      .line3 {
        width: 1200px;
        height: 1200px;
      }

      .shadow-box {
        position: absolute;
        left: 0;
        height: 260px;
        width: 100%;
        transform: scale(1.8);
        z-index: 1;
      }

      .shadow-box-bottom {
        bottom: 0;
        background: linear-gradient(to top, #fbfaff, 90%, transparent);
      }

      .animation-brand {
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .animation-brand {
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        z-index: 2;
        transition: all 0.5s ease-in-out;
        opacity: 0;
      }

      img:nth-child(1) {
        width: 100px;
        height: 100px;
      }

      img:nth-child(2) {
        width: 145px;
        height: 44px;
      }

      img:nth-child(3) {
        width: 247px;
        height: 48px;
      }

      img:nth-child(4) {
        width: 119px;
        height: 66px;
      }

      img:nth-child(5) {
        width: 141px;
        height: 53px;
      }

      img:nth-child(6) {
        width: 100px;
        height: 100px;
      }

      img:nth-child(7) {
        width: 145px;
        height: 50px;
      }

      img:nth-child(8) {
        width: 174px;
        height: 54px;
      }
      img:nth-child(9) {
        width: 195px;
        height: 37px;
      }
    }

    .animation-brand-active {
      img {
        opacity: 1;
      }
      img:nth-child(1) {
        transform: translateX(calc(-50% - 430px)) translateY(calc(-50% - 430px));
      }

      img:nth-child(2) {
        transform: translateX(calc(-50% - 450px)) translateY(calc(-50% - 130px));
      }

      img:nth-child(3) {
        transform: translateX(calc(-50% - 410px)) translateY(calc(-50% + 200px));
      }

      img:nth-child(4) {
        transform: translateX(calc(-50% - 160px)) translateY(calc(-50% + 440px));
      }

      img:nth-child(5) {
        transform: translateX(calc(-50%)) translateY(calc(-50% - 470px));
      }

      img:nth-child(6) {
        transform: translateX(calc(-50% + 160px)) translateY(calc(-50% - 270px));
      }

      img:nth-child(7) {
        transform: translateX(calc(-50% + 460px)) translateY(calc(-50% - 130px));
      }

      img:nth-child(8) {
        transform: translateX(calc(-50% + 460px)) translateY(calc(-50% + 150px));
      }
      img:nth-child(9) {
        transform: translateX(calc(-50% + 260px)) translateY(calc(-50% + 400px));
      }
    }
  }

  .about-case {
    margin-top: -400px;
    > div {
      flex: 1;
      .case {
        margin-bottom: 24px;
        img {
          width: 100%;
        }
      }
    }
    .case1 {
      img {
        height: 444px;
      }
    }

    .case-left {
      margin-right: 24px;
      .case2 {
        img {
          height: 438px;
        }
      }
    }
    .case-right {
      .case4 {
        background: #f4f4f4;
        border-radius: 32px 32px 32px 32px;
        padding: 26px 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #402d81;
        line-height: 38px;

        p {
          position: relative;
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;

          &::before {
            content: "";
            width: 6px;
            height: 6px;
            border-radius: 50%;
            overflow: hidden;
            background-color: #402d81;
            margin-top: 12px;
          }

          span {
            flex: 1;
            padding-left: 14px;
          }
        }
      }
    }
  }
}

.section4 {
  text-align: center;
  margin-top: 154px !important;
  h1 {
    margin-bottom: 66px;
  }

  p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 40px;
    color: #402d81;
  }

  .img-box {
    width: 100%;
    margin: auto;
    padding: 32px;
    padding-top: 0;
    background: #f7f0fe;
    margin-top: 80px;
    border-radius: 32px 32px 32px 32px;
    img {
      width: 100%;
      margin-top: 32px;
    }
    .img-box3 {
      overflow: hidden;
      img {
        float: left;
        width: 50%;
      }
      img:nth-child(1) {
        width: calc(50% - 34px);
        margin-right: 32px;
      }
    }
  }
}

.section5 {
  margin-top: 110px !important;
  text-align: center;
  margin-bottom: 154px !important;
  img {
    width: 40px;
    height: 26px;
    vertical-align: top;
  }
  span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 300;
    font-size: 48px;
    color: #adadad;
    line-height: 100px;
    text-align: center;
    flex: 1;
    overflow: hidden;
  }
}
</style>
